import { MapPin } from 'lucide-react';

interface PlpNoStoreFoundProps {
  onChangePincode: () => void;
  onExploreAll: () => void;
}

export function PlpNoStoreFound({ onChangePincode, onExploreAll }: PlpNoStoreFoundProps) {
  return (
    <div className="flex min-h-[40vh] flex-col items-center justify-center px-6 text-center">
      <div className="relative mb-6 flex items-end justify-center">
        <MapPin className="h-14 w-14 text-gray-800" strokeWidth={1.5} aria-hidden />
        <span className="absolute bottom-0 left-1/2 h-2 w-10 -translate-x-1/2 rounded-full bg-gray-300/60 blur-sm" aria-hidden />
      </div>
      <p className="mb-6 max-w-xs text-sm leading-relaxed text-gray-700">
        Currently, there are no stores in your area, but we&apos;re working on it! Double-check your pincode or try a different one.
      </p>
      <button
        type="button"
        className="mb-4 rounded-sm bg-[#E84C3D] px-8 py-3 text-xs font-bold uppercase tracking-widest text-white hover:bg-[#c73d30] transition-colors"
        onClick={onChangePincode}
      >
        Change Pincode
      </button>
      <p className="text-sm text-gray-600">
        or{' '}
        <button
          type="button"
          className="text-[#2B5DA9] underline-offset-2 hover:underline"
          onClick={onExploreAll}
        >
          Explore Other Designs
        </button>
      </p>
    </div>
  );
}
